import { useEffect, useMemo, useRef, useState } from "react"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material/styles"

export function useDesiredHeight(
  desiredBottom: number | undefined = undefined,
  upToBreakpoint: "xl" | "lg" | "md" | "sm" | "xs" = "xl"
) {
  const ref = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)
  const [top, setTop] = useState<number>(0)
  const [left, setLeft] = useState<number>(0)
  const [right, setRight] = useState<number>(0)

  const [bottom, setBottom] = useState<number>(0)

  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down(upToBreakpoint))

  useEffect(() => {
    if (ref.current) {
      const { width, height, top, left, right, bottom } = ref.current.getBoundingClientRect()
      setWidth(width)
      setHeight(height)
      setTop(top)
      setLeft(left)
      setRight(right)
      setBottom(bottom)
    }
  }, [ref.current, smallScreen])

  const desiredHeight = useMemo(() => {
    if (smallScreen || desiredBottom === undefined) {
      return undefined
    }
    if (desiredBottom) {
      //compute screen height
      const screenHeight = window.innerHeight
      //compute desired height
      const dHeight = screenHeight - desiredBottom - top
      return dHeight // >= height ? dHeight : height
    }
    return undefined
  }, [top, desiredBottom, smallScreen])

  return {
    ref,
    width,
    height,
    top,
    left,
    right,
    bottom,
    desiredHeight,
  }
}
